import * as React from 'react';
import { connect } from 'react-redux';
import { surveyList, updateSurveyListFilter, updateSurveyListPage, editSurvey, deleteSurvey } from 'src/actions/action.survey';
import SurveyListComponent from '../components/surveys/SurveyListComponent';
import { Grid, Typography, Button } from '@material-ui/core';
import { SurveyWrapper } from 'src/styles/survey';
import { ApplicationMain } from '../styles/common';
import LoaderComponent from 'src/components/common/loader.component';
import { push } from 'connected-react-router';

class SurveyListContainer extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.GoToCreateSurvey = this.GoToCreateSurvey.bind(this);
        this.deleteSurvey = this.deleteSurvey.bind(this);
    }

    componentDidMount() {
        this.props.updateSurveyListPage({
            skip: 0,
            take: 10
        });
        this.props.surveyList();
    }

    GoToCreateSurvey(showAssignments: any) {
        const path = 'survey/0';
        this.props.redirectTo(path);
    }

    updateSurveyListFilter = (data: any) => {
        this.props.updateSurveyListFilter(data)
    }

    updateSurveyListPage = (data: any) => {
        this.props.updateSurveyListPage(data);
    }

    deleteSurvey(surveyId: number) {
        this.props.deleteSurvey(surveyId)
    }

    render() {
        return (
            <ApplicationMain>
                <LoaderComponent sending={this.props.show} />
                <SurveyWrapper>
                    <div className="pageContainer">

                        <div className="pageHeading">
                            <Grid container={true} spacing={8}>
                                <Grid item={true} xs={6}>
                                    <div className="pageHeadingTitle">
                                        <Typography component="h2" variant="title" align="left" gutterBottom={true} className="pageTitle">
                                            Surveys
                                        </Typography>
                                    </div>
                                </Grid>
                                <Grid item={true} xs={6}>
                                    <div className="text-right">
                                        <Button type="button" className="btn-blue-primary" variant="outlined" size="medium" onClick={this.GoToCreateSurvey.bind(this, true)}>
                                            Create Survey
                                        </Button>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>

                        <div className="pageContent">
                            <Grid container={true}>
                                <Grid item={true} xs={12}>
                                    <div className="">
                                        <SurveyListComponent
                                            surveys={this.props.surveys}
                                            filter={this.props.filter}
                                            skip={this.props.skip}
                                            take={this.props.take}
                                            updateSurveyListPage={this.updateSurveyListPage}
                                            updateSurveyListFilter={this.updateSurveyListFilter}
                                            deleteSurvey={this.deleteSurvey}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </div>

                    </div>
                </SurveyWrapper>
            </ApplicationMain>
        );
    }
}

const mapStateToProps = (state: any, props: any) => {
    return {
        show: state.common.show,
        surveys: props && props.userId === 1 ? state.survey.surveys : state.survey.surveyList,
        filter: state.survey.filter,
        skip: state.survey.page.skip,
        take: state.survey.page.take,
        isDashboardSurvey: state.survey.isDashboardSurvey,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        surveyList: () => dispatch(surveyList()),
        updateSurveyListFilter: (data: any) => dispatch(updateSurveyListFilter(data)),
        updateSurveyListPage: (data: any) => dispatch(updateSurveyListPage(data)),
        editSurvey: (data: any) => dispatch(editSurvey(data)),
        deleteSurvey: (data: any) => dispatch(deleteSurvey(data)),
        redirectTo: (path: string) => dispatch(push(path)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SurveyListContainer);


// WEBPACK FOOTER //
// ./src/containers/SurveyListContainer.tsx